import React from 'react';

// COMPONENTS:
import UserBlock from '../tableComponents/UserBlock';

const OwnedBy = ({ user }) => (
  <td>
    <UserBlock user={user} />
  </td>
);

export default OwnedBy;
